module.exports = __webpack_public_path__ + "img/4.a06b35ab.jpg";